import { getLevel, getPhase } from '@/common/utils/scopeAndSequence';

export default function getActivityContext(
  activityName: string,
  levelOrPhaseNum: number,
  customLevelDescription?: string,
): string {
  if (customLevelDescription) return customLevelDescription;

  if (activityName === 'assessment') {
    if (levelOrPhaseNum === 0) {
      return `Screener (Phases 1-3)`;
    }
    const phase = getPhase(levelOrPhaseNum);
    if (!phase) return `Phase ${levelOrPhaseNum}`;
    return `Phase ${levelOrPhaseNum} - ${phase.description}`;
  }

  const level = getLevel(levelOrPhaseNum);
  if (!level) return `Level ${levelOrPhaseNum}`;
  return `Level ${levelOrPhaseNum} - ${level.description}`;
}
